import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QuizQuestion } from 'src/app/models';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';

@Component({
  selector: 'app-module6-rw',
  templateUrl: './module6-rw.component.html',
  styleUrls: ['./module6-rw.component.css', '../rentwise.component.css']
})
export class Module6RwComponent implements OnInit, OnDestroy {

  module = 6;
  page = 1
  flag = false;

  // Last module, determines whether to show course complete or the module
  courseComplete = false;

  // Contains all questions for the module
  questions: QuizQuestion[] = [];



  constructor(private courseService: CoursesService, private quizService: QuizService, private router: Router) { }

  ngOnInit(): void {
    this.courseService.setCurrentCourseBy('RentWise');

    // Open the furthest page
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      this.page = this.courseService.currentCourse.furthestPageID + 1;
    }

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f3444bfadf713839b08cde").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });
  }

  // Reset
  ngOnDestroy(): void {
    this.courseComplete = false;
  }

  // Update furthestModuleID
  updateProgress() {
    const postTestRequired = this.courseService.currentCourse.postTestRequired
      ? !this.courseService.currentCourse.postTestPassed
      : false;

    if (this.courseService.currentCourse.furthestModuleID < this.module) {
      this.courseService.updateFurthestModule().toPromise();
    }

    // Post-evaluation required
    if (this.courseService.currentCourse.furthestModuleID == 6 && postTestRequired) {
      this.router.navigate([`/post-evaluation-rw`]);
    }

    // Course is complete
    if (this.courseService.currentCourse.furthestModuleID == 6 && !postTestRequired) {
      this.courseComplete = true;
      this.courseService.markAsCompleted().toPromise();
    }
  }

  // Update furthestPageID
  updatePageProgress() {
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      if (this.courseService.currentCourse.furthestPageID < this.page) {
        this.courseService.updateFurthestPage(this.page).toPromise();
      }
    }
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
    }

    // Review
    else {
      this.page = 1
    }
  }

  next(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.page += 1;
    window.scrollTo(0,0);
    this.updatePageProgress();
    return true;
  }

  back(){
    this.page -= 1;
    window.scrollTo(0,0);
    return true;
  }

  model7 = {
    model7_Q1: undefined,
    model7_Q2: undefined,
    model7_Q3: undefined,
    model7_Q4: undefined,
    model7_Q5: undefined,
    model7_Q6: undefined,
    model7_Q7: undefined,
  };

  model7_Q1 = false;
  model7_Q2 = false;
  model7_Q3 = false;
  model7_Q4 = false;
  model7_Q5 = false;
  model7_Q6 = false;
  model7_Q7 = false;

  m7_Q1() {
    this.model7_Q1 = true;
  }
  m7_Q2() {
    this.model7_Q2 = true;
  }
  m7_Q3() {
    this.model7_Q3 = true;
  }
  m7_Q4() {
    this.model7_Q4 = true;
  }
  m7_Q5() {
    this.model7_Q5 = true;
  }
  m7_Q6() {
    this.model7_Q6 = true;
  }
  m7_Q7() {
    this.model7_Q7 = true;
  }

  setFlag()
  {
    this.flag = true;
  }
  resetFlag()
  {
    this.flag = false;
  }

  activityOneCorrect()
  {
    /*
      If a question is not picked, return false
    */
    if (!this.model7_Q1 || !this.model7_Q2 || !this.model7_Q3 || !this.model7_Q4 || !this.model7_Q5 || !this.model7_Q6 || !this.model7_Q7)
      //If any are true, then return false
   {
    return false;
   }

   if (this.model7.model7_Q1 == true|| this.model7.model7_Q2 == true ||  this.model7.model7_Q3 == true|| this.model7.model7_Q4 == true|| this.model7.model7_Q5 == true
      || this.model7.model7_Q6 == true || this.model7.model7_Q7 == true)
   {
      return false;
   }

   /*
    Default: return true
   */
   return true;
  }
}
